import markupNo from '../resources/no/markup.json';
import markupSe from '../resources/se/markup.json';
import { MarkupLanguageResources } from '../types/MarkupResources';

export const markupI18nResources: MarkupLanguageResources = {
  no: { markup: markupNo },
  se: { markup: markupSe },
};
